// landing/Landing.js
import React from 'react';
import SiteDownloads    from '../common/SiteDownloads';

class Landing extends React.Component {
	render() {
		return(
			<div className="App">
				<div className="inner-site-downloads">
					<SiteDownloads></SiteDownloads>
				</div>
			</div>
		)
	}
}

export default Landing;


/** WEBPACK FOOTER **
 ** ./src/modules/landing/Landing.js
 **/